import React, { createContext, useContext, useEffect, useState } from "react";
import { BASE_TZ, detectDefaultTimezone, ALL_ZONES } from "@/lib/timezone";

const STORAGE_KEY = "ff-timezone";

const TimezoneContext = createContext({
  timezone: BASE_TZ,
  setTimezone: () => {},
  isBase: true,
});

export function TimezoneProvider({ children }) {
  const [timezone, setTimezoneState] = useState(BASE_TZ);

  useEffect(() => {
    let initial = null;
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored && ALL_ZONES.some((z) => z.value === stored)) initial = stored;
    } catch {}
    if (!initial) initial = detectDefaultTimezone();
    setTimezoneState(initial);
  }, []);

  const setTimezone = (tz) => {
    setTimezoneState(tz);
    try { localStorage.setItem(STORAGE_KEY, tz); } catch {}
  };

  return (
    <TimezoneContext.Provider value={{ timezone, setTimezone, isBase: timezone === BASE_TZ }}>
      {children}
    </TimezoneContext.Provider>
  );
}

export function useTimezone() {
  return useContext(TimezoneContext);
}
